module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-component"
  }, [_c('div', {
    staticClass: "component-title-box"
  }, [_c('component-title', {
    attrs: {
      "config": _vm.config
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-component-components"
  }, [_vm._l((_vm.getComponents), function(component) {
    return [_c(_vm.loadComponent(component.type), {
      tag: "component",
      attrs: {
        "config": component.config,
        "eventBus": _vm.$root,
        "routeParams": _vm.routeParams,
        "moduleName": _vm.moduleName
      }
    })]
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3978ce9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderComponent.vue
// module id = 1270
// module chunks = 2